import client from '../client';
import type { ContactSubmission } from '../../types/contact';
import type { ApiResponse, PaginationParams } from '../../types/api';

export const contactsApi = {
  list: async (storeId: string, params?: PaginationParams & { status?: string }) => {
    const res = await client.get<ApiResponse<{ contacts: ContactSubmission[]; pagination: { page: number; limit: number; total: number; pages: number } }>>(
      `/dashboard/${storeId}/contacts`,
      { params },
    );
    return res.data.data!;
  },

  get: async (storeId: string, contactId: string) => {
    const res = await client.get<ApiResponse<{ contact: ContactSubmission }>>(
      `/dashboard/${storeId}/contacts/${contactId}`,
    );
    return res.data.data!;
  },

  update: async (storeId: string, contactId: string, data: { status?: string; reply?: string }) => {
    await client.patch(`/dashboard/${storeId}/contacts/${contactId}`, data);
  },

  delete: async (storeId: string, contactId: string): Promise<void> => {
    await client.delete(`/dashboard/${storeId}/contacts/${contactId}`);
  },
};
